import { InjectionToken } from '@angular/core';
import { TrackingPlan } from './tracking.service';

/**
 * Opt-in of an app's SHARED checkout (libs/credo order wizard) into the Tracking
 * Engine (docs/tracking/EVENT_CONTRACT_V1.md §3). The page id belongs to the app,
 * never to the library: an app that does not provide this token keeps the wizard
 * completely silent.
 *
 * Provided by `createAppConfig({ tracking: { checkout: { … } } })`.
 */
export interface TrackingCheckoutConfig {
  /** Tracking page id of the app checkout, e.g. `f3-checkout` (registry `tracking_pages`). */
  pageId: string;
  /**
   * `checkout_started.source_page_id` when the wizard itself is the first checkout
   * screen of the session (deep link, menu). Defaults to the app's consent page id
   * (`<brand>-app`), else `pageId`.
   */
  sourcePageId?: string;
  /** Product code -> `checkout_started.plan`. A product not listed sends no plan. */
  plans?: Record<string, TrackingPlan>;
}

export const TRACKING_CHECKOUT_CONFIG = new InjectionToken<TrackingCheckoutConfig>('TRACKING_CHECKOUT_CONFIG');
